import { gql } from 'graphql-request';

export const TASK_FRAGMENT = gql`
  fragment Task on Task {
    id
    displayName
    templateId
    tags
    requireApprovalByRole {
      displayName
      id
      ownerID
    }
    dependsOn {
      id
      displayName
      executor {
        id
        displayName
        url
        processId
      }
    }
    executor {
      id
      displayName
      url
      processId
      ownerID
    }
    assignedTo {
      id
      ownerID
      displayName
      assignees {
        id
        ownerID
        displayName
      }
    }
  }
`;

export const PROCESS_FRAGMENT = gql`
  ${TASK_FRAGMENT}
  fragment Process on Process {
      id
      displayName
      descriptiveName
      tags
      ownerID
      configuration {
        isActive
      }
      assignedTo {
        id
        ownerID
        displayName
        assignees {
          id
          ownerID
          displayName
          properties {
            key
            value
          }
        }
      }
      tasks {
        ...Task
      }
  }
`;

export const GET_PROCESSES = gql`
  ${PROCESS_FRAGMENT}
  query processes {
    processes {
      ...Process
    }
  }
`;

export const GET_PROCESS = gql`
  ${PROCESS_FRAGMENT}
  query process($id: ID!) {
    process(id: $id) {
      ...Process
      tasks {
        ...Task
        template {
          id
          ... on ContractTemplate {
            __typename
          }
          ... on FormTemplate {
            __typename
          }
          ... on CalculationTemplate {
            __typename
          }
          ... on BusTemplate {
            __typename
          }
        }
      }
    }
  }
`;
